import { formatPrice } from '@grandvisionhq/utils';
import { DiscountType } from '../../../../../types/product.js';

const useDiscountLabel = (value, type, currency, locale)=>{
    if (type === DiscountType.RELATIVE) {
        return `-${value}%`;
    }
    if (type === DiscountType.ABSOLUTE && !!locale) {
        const formattedDiscount = formatPrice({
            locale,
            value,
            currency,
            isCentAmount: false
        });
        return `-${formattedDiscount}`;
    }
};

export { useDiscountLabel };
//# sourceMappingURL=use-discount-label.js.map
